export class ProductInventoryEndpoints {
    private static readonly BASE = '/portal/inventory/product';

    static list(query: string): string {
        return `${this.BASE}${query}`;
    }

    static get(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static create(): string {
        return this.BASE;
    }

    static update(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static delete(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static activate(id: string): string {
        return `${this.BASE}/${id}/activate`;
    }

    static deactivate(): string {
        return `${this.BASE}/deactivate`;
    }

    static statuses(): string {
        return `${this.BASE}/statuses`;
    }

    static unitOfMeasurementList(): string {
        return `${this.BASE}/udm-list`;
    }

    static vatCodeList(): string {
        return `${this.BASE}/vat-code-list`;
    }

    static categoryNames(): string {
        return `${this.BASE}/category-names`;
    }

    static allProducts(): string {
        return `${this.BASE}/list-all-products`;
    }

    static currencies(): string {
        return `${this.BASE}/currencies`;
    }

    static eanAvailability(ean: string): string {
        return `${this.BASE}/ean-availability?ean=${encodeURIComponent(ean)}`;
    }

    static planogramProductsWithHasPhoto(): string {
        return `${this.BASE}/planogram-with-has-photo`;
    }

    static photo(ean: string): string {
        return `${this.BASE}/photo?ean=${encodeURIComponent(ean)}`;
    }
}